/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import { navigate, useLocation } from "@reach/router";
import useViewer from "../../../hooks/useViewer";
import { WidthMax, HeroContainerWrap } from "../Register";
import styled from "styled-components";
import { Paper, Grid } from "@material-ui/core";
import { PrimaryCTAButton } from "../../common/Buttons";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";

const SafeHarbor = () => {
  const { setUserObject, setToken } = useViewer();
  const location = useLocation();

  const handleAccept = () => {
    localStorage.setItem("dsnl_cookies_enabled", true);
    localStorage.setItem("pollArray", location?.state?.pollArray);
    localStorage.setItem("auth_token", location?.state?.auth_token);
    localStorage.setItem("role", "eventViewer");
    setToken(location?.state?.auth_token);
    navigate("/live");
  };

  const handleDecline = (returnUrl) => {
    localStorage.setItem("dsnl_cookies_enabled", false);
    localStorage.removeItem("auth_token");
    localStorage.removeItem("pollArray");
    localStorage.removeItem("dsnl_cookies_enabled");
    setUserObject({});
    navigate(returnUrl);
  };

  return (
    <Layout
      image={
        location?.state?.arrayOfObject?.theme?.themeGeneral?.backgroundImage
      }
      bgColor={
        location?.state?.arrayOfObject?.theme?.themeGeneral?.bodyBackgroundColor
      }
    >
      <WidthMax id="about">
        <HeroContainerWrap id="hero">
          <DrawerContainer>
            <Container>
              <Paper elevation={3} style={{ padding: "16px" }}>
                <Grid
                  container
                  spacing={2}
                  style={{
                    marginTop: "16px",
                    padding: 16,
                  }}
                >
                  <Description
                    dangerouslySetInnerHTML={{
                      __html: location?.state?.userData?.comment,
                    }}
                  />
                </Grid>
                <Grid
                  container
                  spacing={2}
                  style={{ marginTop: "16px", padding: 16 }}
                >
                  <Grid
                    item
                    xs={12}
                    style={{
                      width: "30%",
                      display: "flex",
                      marginTop: "10px",
                      justifyContent: "center",
                    }}
                  >
                    <PrimaryCTAButton
                      style={{
                        marginLeft: 8,
                        padding: "10px 10px",
                        width: "20%",
                      }}
                      onClick={() =>
                        handleDecline(location?.state?.userData?.returnUrl)
                      }
                    >
                      Decline
                    </PrimaryCTAButton>
                    <PrimaryCTAButton
                      style={{
                        marginLeft: 8,
                        padding: "10px 10px",
                        width: "20%",
                      }}
                      onClick={handleAccept}
                    >
                      Accept
                    </PrimaryCTAButton>
                  </Grid>
                </Grid>
              </Paper>
            </Container>
          </DrawerContainer>
        </HeroContainerWrap>
      </WidthMax>
    </Layout>
  );
};

export default SafeHarbor;

const Container = styled.div`
  margin: 0 15px;
  background-color: white;
  outline: none;
  border-radius: 8px;
  @media ${theme?.breakpoints?.sm_up} {
    margin: 0;
  }
`;

const Layout = styled.div`
  max-height: 100vh;
  height: 100%;
  overflow-y: scroll;
  scrollbar-width: none; /* Hide scrollbar in Firefox */
  background: ${({ image, bgColor }) =>
    image ? `url(${image}) no-repeat center center` : bgColor};
  background-size: cover;
`;

const DrawerContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  @media ${theme?.breakpoints?.sm_up} {
    width: 95%;
    max-height: 95vh;
    border-radius: 10px;
  }
`;

export const Description = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 12px;
  line-height: 1.71;
  color: ${COLORS.COLOR_DARK};
  text-align: center;
  width: 100%;
  @media ${theme?.breakpoints?.sm_up} {
    font-size: 14px;
  }
`;
